import 'process';
import 'core-js/stable';
import 'core-js/features';
import 'regenerator-runtime/runtime';

import '@formatjs/intl-locale/polyfill';
import '@formatjs/intl-getcanonicallocales/polyfill';

import {render} from 'react-dom';
import {createBrowserHistory} from 'history';
import configureStore from './store/configure-store';
import Root from './containers/Root';

const history = createBrowserHistory();
const store = configureStore(history);

render(
  <Root store={store} history={history} />,
  document.getElementById('app'),
);

if (module.hot) {
  module.hot.accept('./containers/Root', () => {
    render(
      <Root store={store} history={history} />,
      document.getElementById('app'),
    );
  });
}
